import axios from "./axiosInstance";
import {
  AuthorizedPickUpPersonApiResponse,
  AuthorizedPickUpPersonsApiResponse,
  AuthorizedPickUpPersonCreatePayload,
  AuthorizedPickUpPersonUpdatePayload,
  AuthorizedPickUpPersonQueryParams
} from "../types/authorizedPickUpPersonTypes";

export const getAuthorizedPickUpPersons = async (params: AuthorizedPickUpPersonQueryParams): Promise<AuthorizedPickUpPersonsApiResponse> => {
  const response = await axios.get<AuthorizedPickUpPersonsApiResponse>("/authorized-pickup-persons", { params });
  return response.data;
};

export const getAuthorizedPickUpPersonById = async (id: string): Promise<AuthorizedPickUpPersonApiResponse> => {
  const response = await axios.get<AuthorizedPickUpPersonApiResponse>(`/authorized-pickup-persons/${id}`);
  return response.data;
};

export const getAuthorizedPickUpPersonsByGuardianId = async (guardianId: string, params?: { page?: number; limit?: number }): Promise<AuthorizedPickUpPersonsApiResponse> => {
  const response = await axios.get<AuthorizedPickUpPersonsApiResponse>(`/authorized-pickup-persons/guardian/${guardianId}`, { params });
  return response.data;
};

export const getAuthorizedPickUpPersonsByStudentId = async (studentId: string, params?: { page?: number; limit?: number }): Promise<AuthorizedPickUpPersonsApiResponse> => {
  const response = await axios.get<AuthorizedPickUpPersonsApiResponse>(`/authorized-pickup-persons/student/${studentId}`, { params });
  return response.data;
};

export const createAuthorizedPickUpPerson = async (payload: AuthorizedPickUpPersonCreatePayload): Promise<AuthorizedPickUpPersonApiResponse> => {
  const response = await axios.post<AuthorizedPickUpPersonApiResponse>("/authorized-pickup-persons", payload);
  return response.data;
};

export const updateAuthorizedPickUpPerson = async (id: string, payload: AuthorizedPickUpPersonUpdatePayload): Promise<AuthorizedPickUpPersonApiResponse> => {
  const response = await axios.put<AuthorizedPickUpPersonApiResponse>(`/authorized-pickup-persons/${id}`, payload);
  return response.data;
};

export const deleteAuthorizedPickUpPerson = async (id: string): Promise<AuthorizedPickUpPersonApiResponse> => {
  const response = await axios.delete<AuthorizedPickUpPersonApiResponse>(`/authorized-pickup-persons/${id}`);
  return response.data;
};